import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { HistoryFacade } from '../history-entries';
import { WorkspaceFacade } from '../workspace';
import { ChatMessage } from './global-chat.models';
import { GlobalChatActions } from './global-chat.actions';
import { selectGlobalChatError, selectGlobalChatLoading, selectGlobalChatMessages } from './global-chat.selectors';

@Injectable({ providedIn: 'root' })
export class GlobalChatFacade {
  private store = inject(Store);
  private workspace = inject(WorkspaceFacade);
  private history = inject(HistoryFacade);

  readonly chatMessages = toSignal(this.store.select(selectGlobalChatMessages), { initialValue: [] as ChatMessage[] });
  readonly loading = toSignal(this.store.select(selectGlobalChatLoading), { initialValue: false });
  readonly error = toSignal(this.store.select(selectGlobalChatError), { initialValue: null });
  readonly activeProjectId = this.workspace.activeProjectId;

  load(): void {
    this.store.dispatch(GlobalChatActions.load());
  }
  setChatMessages(messages: ChatMessage[]): void {
    this.store.dispatch(GlobalChatActions.setChatMessages({ messages }));
  }
  async logChatEvent(text: string, kind: 'user' | 'assistant' | 'info' | 'update' | 'error' = 'info'): Promise<void> {
    const projectId = this.activeProjectId();
    if (!projectId) return;
    await this.history.add(projectId, 'project.globalChat', text, kind as any);
  }
}
